import waitForElement from "./waitForElement"

const PRIMER_LOCALES = [
  "de",
  "el",
  "en",
  "es",
  "fr",
  "pl",
  "pt",
  "bg",
  "hu",
  "ro",
  "ru",
  "sk",
  "nl",
]

export default () => ({
  primerLoading: true,

  submitting: false,

  paymentMethod: null,

  error: null,
  initError: null,

  // Checks for the compability with locale
  isPrimerLocale(locale) {
    return PRIMER_LOCALES.includes(locale || "en")
  },

  getTranslatedError(key) {
    if (!key) return primerTranslations.errors.default

    const normalizedKey = key.trim().replace(/[+ ]+/g, "_").toUpperCase()
    return primerTranslations.errors[normalizedKey] || primerTranslations.errors.default
  },

  determineErrorMessage() {
    const searchParams = new URLSearchParams(window.location.search)

    const getErrorMessage = (paramKey) => {
      const key = searchParams.get(paramKey)
      return key ? this.getTranslatedError(key) : null
    }

    const cardIssuerErrorMessage = getErrorMessage("card_issuer")
    const primerErrorMessage = getErrorMessage("primer_error")

    return cardIssuerErrorMessage || primerErrorMessage || primerTranslations.errors.default
  },

  async initPrimer({ checkoutCompletePath }) {
    if (document.getElementById("primer-checkout-submit-button-container")) {
      return window.location.reload()
    }

    const searchParams = new URLSearchParams(window.location.search)
    if (searchParams.has("primer_error")) {
      this.error = this.determineErrorMessage()
      requestAnimationFrame(() => this.scrollToPrimer())
    }

    this.primerLoading = true

    await waitForElement("#primer-submit-button")

    const submitButton = document.getElementById("primer-submit-button")
    const orBlock = document.getElementById("primer-or-block")

    let clientSession, checkout

    try {
      clientSession = this.store.values.primerSession || (await this.store.payOrCreateSession(true))
      checkout = await this.showUniversalCheckout({
        checkoutCompletePath,
        clientSession,
        submitButton,
      })
    } catch (error) {
      console.error(error)
      // Handle Uncaught (in promise) Error: The provided `clientToken` has expired.
      try {
        clientSession = await this.store.payOrCreateSession(true)
        checkout = await this.showUniversalCheckout({
          checkoutCompletePath,
          clientSession,
          submitButton,
        })
      } catch (error) {
        console.error(error)
        this.initError = true
      }
    }

    this.primerLoading = false

    submitButton.classList.remove("hidden")
    submitButton.addEventListener(
      "click",
      () => {
        checkout.submit()
      },
      false
    )

    const primerCheckoutCardForm = document.getElementById("primer-checkout-card-form")
    if (primerCheckoutCardForm) {
      primerCheckoutCardForm.before(orBlock)
      orBlock.classList.remove("hidden")
    }

    this.patchTranslations(checkout)
  },

  async showUniversalCheckout({ checkoutCompletePath, clientSession, submitButton }) {
    // TODO: Handle error
    if (!clientSession) {
      this.initError = true
      return
    }

    if (clientSession.instantlyCharged) {
      window.location = `${checkoutCompletePath}#stored-token=${this.store.values.token}`
      return
    }

    const { clientToken } = clientSession
    let selectedPaymentMethodType = null

    const checkout = await Primer.showUniversalCheckout(clientToken, {
      container: "#primer-checkout-container",
      locale: pipelineConfig.language || "en",
      vault: {
        visible: false,
      },
      successScreen: false,
      errorMessage: {
        disabled: true,
        onErrorMessageShow: (message) => {
          // console.log('onErrorMessageShow', message)
          // this.setError()
          // this.scrollToPrimer()
        },
        onErrorMessageHide: (message) => {
          // console.log('onErrorMessageHide', message)
        },
      },
      submitButton: {
        useBuiltInButton: false,
        onVisible: (isVisible) => {
          // console.log({isVisible})
          submitButton.classList.remove("hidden")
        },
        onDisable: (isDisabled) => {
          // console.log({isDisabled})
          submitButton.disabled = isDisabled
          this.listenExitIntent = !isDisabled
        },
        onLoading: (isLoading) => {
          // console.log({isLoading})
          submitButton.classList.remove("hidden")
          submitButton.classList.add("loading")
        },
      },
      card: {
        cardholderName: {
          placeholder: primerTranslations.name_placeholder,
        },
        cardNumber: {
          placeholder: "1234 1234 1234 1234",
        },
        expiryDate: {
          placeholder: primerTranslations.expiry_placeholder,
        },
        cvv: {
          placeholder: "●●●",
        },
      },
      paypal: {
        buttonColor: "gold",
        buttonShape: "rect",
        paymentFlow: "PREFER_VAULT",
      },
      googlePay: {
        captureBillingAddress: true,
      },
      applePay: {
        captureBillingAddress: true,
      },
      style: {
        fontFaces: [
          {
            fontFamily: "Acumin Pro",
            src: `url("${window.origin}${pipelineConfig.pathPrefix}fonts/AcuminPro-Book.woff2") format("woff2")`,
          },
        ],
        input: {
          base: {
            fontFamily: "'Acumin Pro', Arial, sans-serif",
            fontSize: "16px",
            lineHeight: "1.25",
            color: "#212121",
            background: "#fff",
            borderColor: "#f0f0f0",
            borderRadius: "3px",
            paddingHorizontal: 12,
            height: 36 + 2, // primer uses -2
            placeholder: {
              color: "#868c8e",
            },
          },
        },
      },
      form: {
        inputLabelsVisible: false,
      },

      onBeforePaymentCreate: ({ paymentMethodType }, handler) => {
        // console.log("onBeforePaymentCreate", paymentMethodType)
        this.paymentMethod = paymentMethodType
        return handler.continuePaymentCreation()
      },

      onPaymentCreationStart: () => {
        // console.log("onPaymentCreationStart")
        this.store.trackViewAndMaybeStatus("SUBMIT_CC_INPUT")
      },

      onCheckoutComplete: ({ payment }) => {
        // console.log("onCheckoutComplete", payment)
        this.submitting = false

        let url = checkoutCompletePath
        if (clientSession) {
          const clientSessionWithPrimer = {
            ...clientSession,
            providerId: payment.id,
          }
          url = `${checkoutCompletePath}?${this.store
            .buildUrlParamsForThankYou(clientSessionWithPrimer)
            .toString()}#stored-token=${this.store.values.token}`
        }

        this.store.clearPrimerSession()
        window.location = url
      },

      onCheckoutFail: async (error, { payment }, handler) => {
        this.submitting = false
        this.listenExitIntent = true
        const searchParams = new URLSearchParams(window.location.search)
        const metadataExists = pipelineConfig?.primerMetadata?.blockedByPayments

        const updateSearchParams = (issuer) => {
          if (issuer) {
            searchParams.set("card_issuer", issuer)
          } else {
            searchParams.delete("card_issuer")
          }
          searchParams.set("primer_error", this.paymentMethod || "")
        }

        const reloadPageWithUpdatedUrl = () => {
          const updatedUrl = `?${searchParams}#stored-token=${this.store.values.token}`
          window.history.replaceState({}, "", updatedUrl)
          window.location.reload()
        }

        updateSearchParams(null)

        if (metadataExists && clientSession) {
          try {
            const paymentId = payment?.id || ""
            const issuerName = await this.getPaymentIssuerName(clientSession, paymentId)

            if (issuerName && this.checkMetadata("blockedByPayments", issuerName)) {
              updateSearchParams(issuerName)
            }
          } catch (err) {
            console.error("Error fetching payment issuer name:", err)
          }
        }

        if (!handler) {
          return reloadPageWithUpdatedUrl()
        }

        this.store.trackViewAndMaybeStatus("FAILED_CHECKOUT")
        handler.showErrorMessage()
        reloadPageWithUpdatedUrl()
      },

      onPaymentMethodAction: (action, data) => {
        if (
          action === "PAYMENT_METHOD_SELECTED" &&
          data.paymentMethodType !== selectedPaymentMethodType
        ) {
          selectedPaymentMethodType = data.paymentMethodType
        }
      },
    })

    this.store.trackViewAndMaybeStatus("INITIATE_CHECKOUT")

    return checkout
  },

  applyCustomLabel(id, text) {
    const currentField = window.document.getElementById(id)

    if (!currentField) return

    // Create our label
    const newLabel = window.document.createElement("div")
    newLabel.dataset.testid = "CreditCardForm.inputLabel"
    newLabel.classList.add("PrimerCheckout__label")
    newLabel.innerHTML = text

    // Display our label
    currentField.prepend(newLabel)
  },

  checkMetadata(key, value) {
    const metadataValues = pipelineConfig?.primerMetadata?.[key]

    if (!metadataValues) {
      return false
    }

    const blockedValues = metadataValues.split(",").map((val) => val.trim().toLowerCase())

    return blockedValues.includes(value.toLowerCase())
  },

  applyCustomErrorMessage(id, text) {
    const currentField = document.getElementById(id)
    if (!currentField) return

    const targetNode = currentField.getElementsByTagName("div")[0]
    if (!targetNode) return

    // Mutation config
    const config = { childList: true }

    // Callback function executes on dom changes
    const callback = (mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          // Apply our custom translation
          if (targetNode.innerHTML !== text && targetNode.innerHTML !== "") {
            targetNode.innerHTML = text
          }
        }
      }
    }
  },

  // Patch the primer translations with ours
  patchTranslations(checkout) {
    this.applyCustomLabel("primer-checkout-card-number-field", primerTranslations.card_number)
    this.applyCustomLabel("primer-checkout-card-expirydate-field", primerTranslations.expiry)
    this.applyCustomLabel("primer-checkout-card-cvv-field", primerTranslations.cvv)
    this.applyCustomLabel("primer-checkout-cardholder-name-field", primerTranslations.name)

    if (!this.isPrimerLocale(pipelineConfig.language)) {
      this.applyCustomErrorMessage(
        "primer-checkout-card-number",
        primerTranslations.errors.empty_field
      )
      this.applyCustomErrorMessage(
        "primer-checkout-card-expirydate-error",
        primerTranslations.errors.empty_field
      )
      this.applyCustomErrorMessage(
        "primer-checkout-card-cvv-error",
        primerTranslations.errors.empty_field
      )
      this.applyCustomErrorMessage(
        "primer-checkout-cardholder-name-error",
        primerTranslations.errors.empty_field
      )
    }
  },

  async getPaymentIssuerName(clientSession, paymentId) {
    if (
      !pipelineConfig ||
      !pipelineConfig.paymentsApiUrl ||
      !paymentId ||
      !clientSession ||
      !clientSession.paymentSessionId
    ) {
      throw new Error(
        `Missing required parameters: ${!pipelineConfig ? "pipelineConfig, " : ""}${
          !paymentId ? "paymentId, " : ""
        }${!clientSession ? "clientSession" : ""}`
      )
    }

    const paymentUrl = new URL(
      `/api/v1/payments/provider-info/primer/${clientSession.paymentSessionId}/${paymentId}`,
      pipelineConfig.paymentsApiUrl
    )

    try {
      const response = await fetch(paymentUrl.toString(), { timeout: 60000 })

      if (!response.ok) {
        throw new Error(`Error fetching payment data: ${response.statusText}`)
      }

      const paymentData = await response.json()
      let issuerName = paymentData?.paymentMethod?.issuerName || "Issuer Name not available"

      issuerName = issuerName.replace(/\+/g, "_")

      return issuerName
    } catch (error) {
      console.error("Failed to fetch payment issuer name:", error)
      throw error
    }
  },

  setError() {
    // console.log("setError", this.paymentMethod)
    this.error = primerTranslations.errors[this.paymentMethod]
  },

  scrollToPrimer() {
    document
      .getElementById("primer")
      .scrollIntoView({ behavior: "smooth", block: "start", inline: "center" })
  },
})
